export default __webpack_public_path__ + "media/images/home/hero/xl-ba13f93e0e697f454ad3ee57d7b00d63.jpg";